// @flow
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useCart from "../../hooks/cart";
// import type { CartState } from '../../reducers/cart'

function ResetCartDlg() {
  const [
    { resetCartDlg: { open = false, type = "CART" } = {} } = {},
    ,
    handleResetCartAction
  ] = useCart();

  return (
    <Dialog
      open={open}
      onClose={() => handleResetCartAction(false, type)}
      aria-labelledby="reset-cart-dialog-title"
      aria-describedby="reset-cart-dialog-description"
    >
      <DialogTitle id="reset-cart-dialog-title">
        {type === "CART" ? "Replace Cart ?" : "Cancel Active Order ?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="reset-cart-dialog-description">
          {type === "CART"
            ? `The cart contains items from another machine. 
              Do you wish to clear the cart and add items from selected machine?`
            : `Can have only 1 live order.
              Do you wish to cancel the order and add items from selected machine?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          autoFocus
          onClick={() => handleResetCartAction(false, type)}
          style={{
            fontWeight: "bold",
            backgroundColor: "#bfd730",
            fontSize: "14px"
          }}
        >
          No
        </Button>
        <Button
          onClick={() => handleResetCartAction(true, type)}
          style={{
            fontWeight: "bold",
            color: "#7f9400",
            fontSize: "14px"
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo<{}>(ResetCartDlg);
